var a={modalContainer:"modalContainer__QyzHfu","spin-animation":"spin-animation__1G54bx","ball-beat-animation":"ball-beat-animation__vh3jt7","hide-scroll-animation":"hide-scroll-animation__Bp21WH"};export{a as default};
